import { object, optional, string, boolean, array, union, literal } from 'valibot';

const imageInfoSchema = object({
  image: optional(string()),
  imageFit: optional(union([literal('cover'), literal('contain')])),
});

const linkSchema = object({
  hide: optional(boolean()),
  altText: optional(string()),
  link: optional(string()),
  style: optional(union([literal('Light'), literal('Dark')])),
  text: optional(string()),
  newtab: optional(boolean()),
});

const highlightSchema = object({
  hide: optional(boolean()),
  text: optional(string()),
});

const titleSchema = object({
  hide: optional(boolean()),
  title1: optional(string()),
  title2: optional(string()),
});

const subtitleSchema = object({
  hide: optional(boolean()),
  subtitle: optional(string()),
});

const descriptionSchema = object({
  hide: optional(boolean()),
  description: optional(string()),
});

const conditionalSchema = object({
  hide: optional(boolean()),
  text: optional(string()),
});

const textbkgcolorSchema = object({
  desktop: optional(string()),
  tabletmobile: optional(string()),
});

const slideSchema = object({
  image: optional(
    object({
      tabletImage: optional(imageInfoSchema),
      mobileImage: optional(imageInfoSchema),
      desktopImage: optional(imageInfoSchema),
      fileurl: optional(string()),
      newtab: optional(boolean()),
      altText: optional(string()),
    }),
  ),
  cta: optional(
    object({
      hide: optional(boolean()),
      cta: optional(linkSchema),
      actionLink: optional(linkSchema),
    }),
  ),
  text: optional(
    object({
      highlight: optional(highlightSchema),
      title: optional(titleSchema),
      subtitle: optional(subtitleSchema),
      description: optional(descriptionSchema),
      conditional: optional(conditionalSchema),
      textbkgcolor: optional(textbkgcolorSchema),
    }),
  ),
});

const navigationConfigSchema = object({
  showNavigationArrows: optional(boolean()),
  showNavigationIndicators: optional(boolean()),
});

const configSchema = object({
  desktop: optional(navigationConfigSchema),
  tablet: optional(navigationConfigSchema),
  mobile: optional(navigationConfigSchema),
});

export const SLIDESHOW_SCHEMA = object({
  hide: optional(boolean(), false),
  config: configSchema,
  slides: array(slideSchema),
});
